(function () {
  'use strict';

  var selectors = {
    purchase: '[data-course-purchase]',
    carousel: '[data-navega-carousel], [data-navega-obras], [data-navega-testimonials]',
    testimonialProgress: '[data-navega-testimonials]',
    accordion: '[data-navega-accordion]',
    buyLink: '[data-navega-buy-scroll]',
    programLink: '[data-navega-program-link]'
  };

  function matchesOrFind(root, selector) {
    var items = [];
    if (root && root.nodeType === 1 && root.matches(selector)) items.push(root);
    if (root && root.querySelectorAll) {
      root.querySelectorAll(selector).forEach(function (item) { items.push(item); });
    }
    return items;
  }

  function formatMoney(cents, wrapper, fallback) {
    if (!Number.isFinite(cents)) return fallback || '';
    var currency = wrapper.dataset.currency || 'BRL';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return fallback || String((cents / 100).toFixed(2)).replace('.', ',');
    }
  }

  function initPurchase(wrapper) {
    if (wrapper.navegaPurchaseController) return;

    var form = wrapper.querySelector('form');
    var select = wrapper.querySelector('[data-course-variant]');
    var submit = wrapper.querySelector('[data-course-submit]');
    var price = wrapper.querySelector('[data-course-price]');
    var comparePrice = wrapper.querySelector('[data-course-compare-price]');
    var installments = wrapper.querySelector('[data-course-installments]');
    var availability = wrapper.querySelector('[data-course-availability]');
    var status = wrapper.querySelector('[data-course-status], .navega-course-purchase__status');
    if (!form || !submit) return;

    var controller = new AbortController();
    var signal = controller.signal;
    var maxInstallments = Math.max(Number(wrapper.dataset.installmentsMax || 12), 1);
    var addLabel = wrapper.dataset.addLabel || 'Comprar curso';
    var unavailableLabel = wrapper.dataset.unavailableLabel || 'Curso indisponível';
    var availableLabel = wrapper.dataset.availableLabel || 'Disponível';
    var soldOutLabel = wrapper.dataset.soldOutLabel || 'Indisponível';
    var addingLabel = wrapper.dataset.addingLabel || 'Adicionando…';
    var addedLabel = wrapper.dataset.addedLabel || 'Item adicionado. Abrindo o carrinho…';
    var optionErrorLabel = wrapper.dataset.optionErrorLabel || 'Não foi possível identificar a opção selecionada. Atualize a página e tente novamente.';
    var addErrorLabel = wrapper.dataset.addErrorLabel || 'Não foi possível adicionar o item. Tente novamente.';
    var showCompare = wrapper.dataset.showCompare !== 'false';

    if (!status) {
      status = document.createElement('p');
      status.className = 'navega-course-purchase__status';
      status.dataset.courseStatus = '';
      status.dataset.navegaGeneratedStatus = 'true';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.appendChild(status);
    }

    function selectedOption() {
      return select && select.options ? select.options[select.selectedIndex] : null;
    }

    function setAvailability(isAvailable) {
      submit.disabled = !isAvailable;
      submit.textContent = isAvailable ? addLabel : unavailableLabel;
      if (availability) availability.textContent = isAvailable ? availableLabel : soldOutLabel;
    }

    function getCurrentAvailability() {
      var option = selectedOption();
      if (select) return Boolean(option) && option.dataset.available === 'true';
      return wrapper.dataset.currentAvailable === 'true';
    }

    function syncVariant(updateUrl) {
      var option = selectedOption();
      if (!option) return;
      var isAvailable = getCurrentAvailability();
      var priceCents = Number(option.dataset.priceCents);

      wrapper.dataset.currentAvailable = isAvailable ? 'true' : 'false';
      if (wrapper.hasAttribute('data-current-variant-id')) wrapper.dataset.currentVariantId = option.value || '';

      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (comparePrice) {
        var compareValue = option.dataset.comparePrice || '';
        comparePrice.textContent = compareValue;
        comparePrice.hidden = !showCompare || !compareValue || compareValue === option.dataset.price;
      }
      if (installments && Number.isFinite(priceCents)) {
        var prefix = wrapper.dataset.installmentPrefix || 'ou';
        var suffix = wrapper.dataset.installmentSuffix || 'no cartão';
        var installmentPrice = formatMoney(priceCents / maxInstallments, wrapper, option.dataset.price);
        installments.textContent = prefix + ' ' + maxInstallments + 'x de ' + installmentPrice + (suffix ? ' ' + suffix : '');
      }
      setAvailability(isAvailable);

      if (updateUrl !== false && window.URL && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url.toString());
        } catch (error) {
          /* A seleção continua funcional quando o preview bloqueia a URL. */
        }
      }
    }

    if (select) {
      select.addEventListener('change', function () { syncVariant(true); }, { signal: signal });
      syncVariant(false);
    }

    form.addEventListener('submit', function (event) {
      if (!window.fetch || submit.disabled) return;
      event.preventDefault();

      var formData = new FormData(form);
      var variantId = formData.get('id');
      var quantity = Math.max(Number(formData.get('quantity') || 1), 1);
      if (!variantId) {
        status.textContent = optionErrorLabel;
        return;
      }

      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.textContent = addingLabel;
      status.textContent = '';

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
      }).then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || data.message || addErrorLabel);
          });
        }
        return response.json();
      }).then(function () {
        status.textContent = addedLabel;
        window.location.assign(root + 'cart');
      }).catch(function (error) {
        status.textContent = error.message || addErrorLabel;
        submit.removeAttribute('aria-busy');
        setAvailability(getCurrentAvailability());
      });
    }, { signal: signal });

    wrapper.navegaPurchaseController = {
      destroy: function () {
        controller.abort();
        if (status && status.dataset.navegaGeneratedStatus === 'true') status.remove();
        delete wrapper.navegaPurchaseController;
      }
    };
  }

  function initCarousel(wrapper) {
    if (wrapper.navegaCarouselController) return;
    var track = wrapper.querySelector('[data-navega-carousel-track], .navega-obras__track, .navega-course-testimonials__grid');
    if (!track) return;

    var controller = new AbortController();
    var signal = controller.signal;
    var previous = wrapper.querySelector('[data-navega-carousel-previous], .navega-obras__nav--prev');
    var next = wrapper.querySelector('[data-navega-carousel-next], .navega-obras__nav--next');
    var media = track.querySelector('.navega-product-work__media, .navega-product-gallery__media, .navega-product-testimonial__media');
    var resizeObserver = null;
    var updateFrame = null;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var step = function () { return Math.max(track.clientWidth * 0.7, 220); };

    function setDisabled(button, disabled) {
      if (!button) return;
      button.disabled = disabled;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }

    function updateState() {
      updateFrame = null;
      var maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      var isStatic = track.scrollWidth <= track.clientWidth + 2;

      if (media) {
        var wrapperRect = wrapper.getBoundingClientRect();
        var mediaRect = media.getBoundingClientRect();
        if (mediaRect.height > 0) {
          wrapper.style.setProperty('--navega-carousel-media-center', Math.round(mediaRect.top - wrapperRect.top + (mediaRect.height / 2)) + 'px');
        }
      }

      wrapper.classList.toggle('navega-product-carousel--static', isStatic);
      setDisabled(previous, isStatic || track.scrollLeft <= 2);
      setDisabled(next, isStatic || track.scrollLeft >= maxScroll - 2);
    }

    function queueStateUpdate() {
      if (updateFrame) window.cancelAnimationFrame(updateFrame);
      updateFrame = window.requestAnimationFrame(updateState);
    }

    if (previous) previous.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reducedMotion ? 'auto' : 'smooth' }); }, { signal: signal });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reducedMotion ? 'auto' : 'smooth' }); }, { signal: signal });
    track.addEventListener('scroll', queueStateUpdate, { signal: signal, passive: true });
    window.addEventListener('resize', queueStateUpdate, { signal: signal });
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(queueStateUpdate);
      resizeObserver.observe(track);
      if (media) resizeObserver.observe(media);
    }
    track.querySelectorAll('img').forEach(function (image) {
      if (!image.complete) image.addEventListener('load', queueStateUpdate, { signal: signal });
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (!signal.aborted) queueStateUpdate();
      });
    }
    queueStateUpdate();

    wrapper.navegaCarouselController = {
      destroy: function () {
        if (updateFrame) window.cancelAnimationFrame(updateFrame);
        if (resizeObserver) resizeObserver.disconnect();
        controller.abort();
        wrapper.style.removeProperty('--navega-carousel-media-center');
        wrapper.classList.remove('navega-product-carousel--static');
        delete wrapper.navegaCarouselController;
      }
    };
  }

  function initTestimonialsProgress(wrapper) {
    if (wrapper.navegaTestimonialsProgressController) return;
    var track = wrapper.querySelector('[data-navega-carousel-track]');
    var progress = wrapper.querySelector('[data-navega-testimonials-progress]');
    if (!track || !progress) return;

    var controller = new AbortController();
    var signal = controller.signal;
    var resizeObserver = null;
    var updateFrame = null;

    function updateProgress() {
      updateFrame = null;
      var scrollWidth = Math.max(track.scrollWidth, 1);
      var maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      var size = Math.min(Math.max((track.clientWidth / scrollWidth) * 100, 12), 100);
      var offset = maxScroll > 0 ? (track.scrollLeft / maxScroll) * (100 - size) : 0;
      progress.style.width = size + '%';
      progress.style.left = offset + '%';
    }

    function queueProgressUpdate() {
      if (updateFrame) window.cancelAnimationFrame(updateFrame);
      updateFrame = window.requestAnimationFrame(updateProgress);
    }

    track.addEventListener('scroll', queueProgressUpdate, { signal: signal, passive: true });
    window.addEventListener('resize', queueProgressUpdate, { signal: signal });
    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(queueProgressUpdate);
      resizeObserver.observe(track);
    }
    track.querySelectorAll('img').forEach(function (image) {
      if (!image.complete) image.addEventListener('load', queueProgressUpdate, { signal: signal });
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (!signal.aborted) queueProgressUpdate();
      });
    }
    queueProgressUpdate();

    wrapper.navegaTestimonialsProgressController = {
      destroy: function () {
        if (updateFrame) window.cancelAnimationFrame(updateFrame);
        if (resizeObserver) resizeObserver.disconnect();
        controller.abort();
        progress.style.removeProperty('width');
        progress.style.removeProperty('left');
        delete wrapper.navegaTestimonialsProgressController;
      }
    };
  }

  function ensureProgramTarget() {
    var target = document.querySelector('#MainContent > .navega-editor-lessons, #MainContent > .navega-editor-module');
    if (!target) return null;
    var existing = document.getElementById('programa');
    if (!existing || existing === target) target.id = 'programa';
    return target;
  }

  function initProgramLink(link) {
    if (link.navegaProgramLinkController) return;
    var controller = new AbortController();
    var signal = controller.signal;

    link.addEventListener('click', function (event) {
      var target = ensureProgramTarget();
      if (!target) return;
      event.preventDefault();
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    }, { signal: signal });

    link.navegaProgramLinkController = {
      destroy: function () {
        controller.abort();
        delete link.navegaProgramLinkController;
      }
    };
  }

  function restoreCourseHeroComposition(composition) {
    if (!composition || !composition.parentNode) return;
    var main = composition.parentNode;
    var left = composition.querySelector(':scope > .navega-course-hero-composition__left');
    var right = composition.querySelector(':scope > .navega-course-hero-composition__right');
    var hero = left && left.querySelector(':scope > .navega-editor-hero');
    var highlights = right && right.querySelector(':scope > .navega-editor-highlights');
    var purchase = right && right.querySelector(':scope > .navega-editor-purchase');
    var trailer = left && left.querySelector(':scope > .navega-editor-media');
    var heroGrid = hero && hero.querySelector('.navega-product-hero__grid');
    var heroContent = heroGrid && heroGrid.querySelector(':scope > .navega-product-hero__content');
    var heroMedia = right && right.querySelector(':scope > .navega-product-hero__media');

    if (heroGrid && heroMedia) {
      var currentMedia = heroGrid.querySelector(':scope > .navega-product-hero__media');
      if (!currentMedia) heroGrid.insertBefore(heroMedia, heroContent || heroGrid.firstChild);
      else if (currentMedia !== heroMedia) heroMedia.remove();
    }

    var reference = composition.nextSibling;
    [hero, highlights, purchase, trailer].forEach(function (section) {
      if (section && section.parentNode) main.insertBefore(section, reference);
    });
    composition.remove();
  }

  function destroyCourseHeroComposition() {
    var main = document.getElementById('MainContent');
    if (main && main.navegaCourseHeroController) main.navegaCourseHeroController.destroy();
  }

  function initCourseHeroComposition() {
    if (!document.body) return;
    var bodyClassName = document.body.className;
    var isCourseFamily = bodyClassName.indexOf('template-suffix-navega-curso') !== -1;
    var isCompassFamily = bodyClassName.indexOf('template-suffix-navega-bussola') !== -1;
    if (!isCourseFamily && !isCompassFamily) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    if (main.navegaCourseHeroController) return;

    var staleComposition = main.querySelector(':scope > [data-navega-course-hero-composition]');
    if (staleComposition) restoreCourseHeroComposition(staleComposition);

    var directSections = Array.prototype.slice.call(main.children);
    var hero = directSections.find(function (section) { return section.classList.contains('navega-editor-hero'); });
    var highlights = directSections.find(function (section) { return section.classList.contains('navega-editor-highlights') && section.querySelector('.navega-product-highlights--hero'); });
    var purchase = directSections.find(function (section) { return section.classList.contains('navega-editor-purchase') && section.querySelector('.navega-product-purchase-wrap--hero_commercial'); });
    var trailer = directSections.find(function (section) { return section.classList.contains('navega-editor-media') && section.querySelector('.navega-product-media--hero-trailer'); });
    var heroSurface = hero && hero.querySelector('.navega-product-hero');
    var heroGrid = heroSurface && heroSurface.querySelector('.navega-product-hero__grid');
    var heroContent = heroGrid && heroGrid.querySelector(':scope > .navega-product-hero__content');
    var heroMedia = heroGrid && heroGrid.querySelector(':scope > .navega-product-hero__media');
    if (!hero || !highlights || !purchase || !trailer || !heroContent || !heroMedia) return;

    var composition = document.createElement('div');
    var left = document.createElement('div');
    var right = document.createElement('div');
    composition.className = 'navega-course-hero-composition';
    composition.setAttribute('data-navega-course-hero-composition', '');
    left.className = 'navega-course-hero-composition__left';
    right.className = 'navega-course-hero-composition__right';

    ['--navega-product-media-ratio', '--navega-product-object-position'].forEach(function (property) {
      var value = heroSurface.style.getPropertyValue(property);
      if (value) composition.style.setProperty(property, value);
    });

    composition.appendChild(left);
    composition.appendChild(right);
    main.insertBefore(composition, hero);
    left.appendChild(hero);
    left.appendChild(trailer);
    right.appendChild(heroMedia);
    right.appendChild(highlights);
    right.appendChild(purchase);

    main.navegaCourseHeroController = {
      destroy: function () {
        restoreCourseHeroComposition(composition);
        delete main.navegaCourseHeroController;
      }
    };
  }

  function initAccordion(accordion) {
    if (accordion.navegaAccordionController) return;
    var controller = new AbortController();
    var signal = controller.signal;

    if (accordion.dataset.multiple !== 'true') {
      accordion.querySelectorAll('details').forEach(function (details) {
        details.addEventListener('toggle', function () {
          if (!details.open) return;
          accordion.querySelectorAll('details[open]').forEach(function (other) {
            if (other !== details) other.open = false;
          });
        }, { signal: signal });
      });
    }

    accordion.navegaAccordionController = {
      destroy: function () {
        controller.abort();
        delete accordion.navegaAccordionController;
      }
    };
  }

  function initBuyLink(link) {
    if (link.navegaBuyLinkController) return;
    var controller = new AbortController();
    var signal = controller.signal;
    var flashTimer = null;

    link.addEventListener('click', function (event) {
      var target = document.querySelector('[data-course-purchase]');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.classList.add('navega-purchase--flash');
      if (flashTimer) window.clearTimeout(flashTimer);
      flashTimer = window.setTimeout(function () { target.classList.remove('navega-purchase--flash'); }, 1600);
    }, { signal: signal });

    link.navegaBuyLinkController = {
      destroy: function () {
        if (flashTimer) window.clearTimeout(flashTimer);
        controller.abort();
        delete link.navegaBuyLinkController;
      }
    };
  }

  function init(root) {
    matchesOrFind(root || document, selectors.purchase).forEach(initPurchase);
    matchesOrFind(root || document, selectors.carousel).forEach(initCarousel);
    matchesOrFind(root || document, selectors.testimonialProgress).forEach(initTestimonialsProgress);
    matchesOrFind(root || document, selectors.accordion).forEach(initAccordion);
    matchesOrFind(root || document, selectors.buyLink).forEach(initBuyLink);
    matchesOrFind(root || document, selectors.programLink).forEach(initProgramLink);
    ensureProgramTarget();
    initCourseHeroComposition();
  }

  function teardown(root) {
    matchesOrFind(root || document, selectors.purchase).forEach(function (item) {
      if (item.navegaPurchaseController) item.navegaPurchaseController.destroy();
    });
    matchesOrFind(root || document, selectors.carousel).forEach(function (item) {
      if (item.navegaCarouselController) item.navegaCarouselController.destroy();
    });
    matchesOrFind(root || document, selectors.testimonialProgress).forEach(function (item) {
      if (item.navegaTestimonialsProgressController) item.navegaTestimonialsProgressController.destroy();
    });
    matchesOrFind(root || document, selectors.accordion).forEach(function (item) {
      if (item.navegaAccordionController) item.navegaAccordionController.destroy();
    });
    matchesOrFind(root || document, selectors.buyLink).forEach(function (item) {
      if (item.navegaBuyLinkController) item.navegaBuyLinkController.destroy();
    });
    matchesOrFind(root || document, selectors.programLink).forEach(function (item) {
      if (item.navegaProgramLinkController) item.navegaProgramLinkController.destroy();
    });
  }

  function ready() { init(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  document.addEventListener('shopify:section:load', function (event) {
    destroyCourseHeroComposition();
    init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    teardown(event.target);
    window.setTimeout(function () {
      destroyCourseHeroComposition();
      initCourseHeroComposition();
    }, 0);
  });
  document.addEventListener('shopify:section:reorder', function () {
    destroyCourseHeroComposition();
    window.setTimeout(function () { init(document); }, 0);
  });
  document.addEventListener('shopify:section:select', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    init(event.target);
    var track = event.target.closest('[data-navega-carousel-track]');
    if (track) event.target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });

  window.NavegaCourse = { init: init, teardown: teardown };
}());
